"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenManager = void 0;
var tslib_1 = require("tslib");
var velvetTokenManager_1 = require("./velvetTokenManager");
/**
 * Generic TokenManager class that manages token operations for different providers.
 */
var TokenManager = /** @class */ (function () {
    function TokenManager() {
        this.tokenProvider = new velvetTokenManager_1.VelvetTokenManager();
    }
    TokenManager.prototype.getTokens = function () {
        try {
            return this.tokenProvider.getTokens();
        }
        catch (error) {
            console.error('Error in TokenManager getValidTokens:', error);
            return null;
        }
    };
    TokenManager.prototype.saveTokens = function (authTokens) {
        try {
            this.tokenProvider.saveTokens(authTokens);
        }
        catch (error) {
            console.error('Error in TokenManager saveTokens:', error);
            throw error;
        }
    };
    TokenManager.prototype.removeTokens = function () {
        try {
            this.tokenProvider.removeTokens();
        }
        catch (error) {
            console.error('Error in TokenManager removeTokens:', error);
            throw error;
        }
    };
    TokenManager.prototype.refreshTokens = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var error_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.tokenProvider.refreshTokens()];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        error_1 = _a.sent();
                        console.error('Error in TokenManager refreshTokens:', error_1);
                        return [2 /*return*/, null];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return TokenManager;
}());
exports.TokenManager = TokenManager;
